const trimTrailingSlash = (url) => url.replace(/\/$/, '');

export const SITE_NAME = 'Roots to Wellness';
export const SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_SITE_URL || 'https://roots2wellness.org'
);
export const SITE_TAGLINE = 'Integrated Health Practitioner';
export const DEFAULT_DESCRIPTION =
  'Lisa Marsh offers integrated health practitioner services in Owen Sound, Ontario — wellness coaching, DESTRESS consultations, and functional lab guidance.';

export const BUSINESS = {
  email: 'lisa@roots2wellness.org',
  founderName: 'Lisa Marsh',
  serviceType: 'Integrated Health Practitioner',
  address: {
    streetAddress: '145 5th Street East',
    addressLocality: 'Owen Sound',
    postalCode: 'N4K 1C4',
    addressRegion: 'ON',
    addressCountry: 'CA',
  },
};

export const DEFAULT_OG_IMAGE_PATH = '/img/homepage.jpg';

export function absoluteUrl(path = '/') {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
}
